module.exports = __webpack_public_path__ + "img/06-thumbnail.20456fff.jpg";